import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { CurriculumService } from 'src/app/_services/curricula.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';

@Component({
  selector: 'app-curriculum-show',
  templateUrl: './curriculum-show.component.html',
  styleUrls: ['./curriculum-show.component.css']
})
export class CurriculumShowComponent implements OnInit {
syllabusList=undefined
  loading=false
  isTesting=false
  server_curriculum_id=0
  curriculum=undefined
  testSyllabusId=0
  dtOptions: DataTables.Settings = {};
  constructor(
    private syllabusService:SyllabusService, private curriculumService:CurriculumService, private activeRoute:ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe(
      params=>{
        this.server_curriculum_id=params['server_curriculum_id'];
        this.syllabusService.getSyllabusListByCurriculum(params['server_curriculum_id']).subscribe({
          next:(data:ResultData)=>{
            this.syllabusList=data.rs.data
            this.loading=false
          }
          ,error:(err)=>{
            console.error('Error loading syllabus', err);
            this.loading=false
          }
        }

        )
      }

    )
    this.getCurriculumId()
  }
getCurriculumId(){
  return this.curriculumService.getCurricularById(this.server_curriculum_id).subscribe(
    {
      next:(data:ResultData)=>{
        this.curriculum=data.rs.data
      }
      ,error:(err)=>{
        console.error('Error loading curriculum', err);
        this.loading=false
      }})
}
  testSyllabus(id:number){
    this.isTesting=true
    this.testSyllabusId=id

    this.syllabusService.testSyllabus(id).subscribe(
      x=>{
        this.isTesting=false
      }
    )

  }

}
